window.onload = function () {
    setTimeout(() => {
        const container = document.querySelector(".localization-selectors");
        if (container) {
            const button = container.querySelector(".localization-toggle");
            if (button && button.textContent.trim().includes("Nederlands")) {
                // console.log("Nederlands button detected inside localization-selectors!");
                startDateUpdater(); 
            }
        }
    }, 500);

    const featureBlock = document.querySelector('[data-block-type="feature-with-icon"]');
    if (featureBlock) {
        const textElement = featureBlock.querySelector(".feature-badge p");
        if (textElement) {
            window.textElementFetch = textElement;
            // console.log(textElement.textContent.trim(), "textElementFetch");
        }
    }
};

function startDateUpdater() {
    function updateDate() {
        const today = new Date();
        let deliveryDate = new Date(today);
        let deliveryText = "";
        
        const daysMapping = {
            1: "MAANDAG",    // Monday
            2: "DINSDAG",    // Tuesday
            3: "WOENSDAG",   // Wednesday
            4: "DONDERDAG",  // Thursday
            5: "VRIJDAG",    // Friday
            6: "ZATERDAG",   // Saturday
            0: "ZONDAG",     // Sunday
        };

        if (today.getDay() === 6) { 
            // Saturday -> Monday delivery
            deliveryDate.setDate(today.getDate() + 2);
            deliveryText = `Vandaag besteld is maandag ${deliveryDate.getDate()} ${deliveryDate.toLocaleString("nl-NL", { month: "long" })} in huis`;
        } else if (today.getDay() === 0) { 
            // Sunday -> Tuesday delivery
            deliveryDate.setDate(today.getDate() + 2);
            deliveryText = `Vandaag besteld is dinsdag ${deliveryDate.getDate()} ${deliveryDate.toLocaleString("nl-NL", { month: "long" })} in huis`;
        } else {
            // Normal case: Next day delivery
            deliveryDate.setDate(today.getDate() + 1);
            deliveryText = `Voor 23:00 besteld is morgen ${deliveryDate.getDate()} ${deliveryDate.toLocaleString("nl-NL", { month: "long" })} in huis`;
        }

        // console.log("Delivery Date: " + deliveryDate.toDateString());
        // console.log("Updated Text: ", deliveryText);

        if (window.textElementFetch) {
            window.textElementFetch.textContent = deliveryText;
        }

        const allSlides = document.querySelectorAll(".essential_annoucement_bar_title_c3936ebd-a8f6-4870-9686-18a7a9426fb0");

        allSlides.forEach((el) => {
            const currentText = el.textContent.trim();
            if (currentText.includes("VOOR 23:00 BESTELD IS MORGEN IN HUIS")) {
                el.textContent = deliveryText.toUpperCase();
                // console.log("✅ Text updated:", el.textContent);


          const announcementWrapper = document.querySelector('html[lang="nl"] .essential_annoucement_bar_wrapper .essential_annoucement_bar_glide__slides.essential_annoucement_bar_slider_container_c3936ebd-a8f6-4870-9686-18a7a9426fb0');
         if (announcementWrapper) {
         announcementWrapper.style.display = 'flex';
          }
              
            }
        });
    }

    updateDate();

    setInterval(updateDate, 86400000);
}


// const observer = new MutationObserver((mutations) => {
//   const upcartPopup = document.querySelector('#upCart');
//   if (upcartPopup && upcartPopup.shadowRoot) {
//     const deliveryDateEl = upcartPopup.shadowRoot.querySelector('#expected-delivery-date');
//     if (deliveryDateEl) {
//       const today = new Date();
//       const day = today.getDay(); // 0 = Sunday, 6 = Saturday

//       let addDays = 1;
//       if (day === 6) {
//         addDays = 2; // Saturday → Monday
//       } else if (day === 0) {
//         addDays = 2; // Sunday → Tuesday
//       }

//       const deliveryDate = new Date();
//       deliveryDate.setDate(deliveryDate.getDate() + addDays);

//       const options = { year: 'numeric', month: 'long', day: 'numeric' };
//       const formattedDate = deliveryDate.toLocaleDateString('nl-NL', options);

//       const finalText = `Wordt geleverd op ${formattedDate}`;
//       console.log(finalText, "finalText");

//       deliveryDateEl.textContent = finalText;
//     }
//   }
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true,
// });

const observer = new MutationObserver((mutations) => {
  const lang = document.documentElement.lang;

  const upcartPopup = document.querySelector('#upCart');
  if (upcartPopup && upcartPopup.shadowRoot) {
    const deliveryDateEl = upcartPopup.shadowRoot.querySelector('#expected-delivery-date');
    const containerDiv = upcartPopup.shadowRoot.querySelector('.custom-verwachte-div');

    // Hide entire block if not lang="nl"
    if (containerDiv && lang !== "nl") {
      containerDiv.style.display = "none";
      return; // Skip rest of the logic
    }

    if (deliveryDateEl && lang === "nl") {
      const today = new Date();
      const day = today.getDay(); // 0 = Sunday, 6 = Saturday

      let addDays = 1;
      if (day === 6) {
        addDays = 2; // Saturday → Monday
      } else if (day === 0) {
        addDays = 2; // Sunday → Tuesday
      }

      const deliveryDate = new Date();
      deliveryDate.setDate(deliveryDate.getDate() + addDays);

      const options = { month: 'long', day: 'numeric' };
      const formattedDate = deliveryDate.toLocaleDateString('nl-NL', options);

      const finalText = `${formattedDate}`;
      deliveryDateEl.textContent = finalText;
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});